// extracted by mini-css-extract-plugin
export default {"root":"nextScanChat_root__iLwqE","placeholder":"nextScanChat_placeholder__cEApq"};